import { TweenLite } from "gsap/all";

export default function () {
    var allPanos, panoVideoPlugin;
    var hotspots = [];
    var windowPopState = false;
    const loadPanoEvent = new Event("loadPano");

    window.onKRPanoReady = function (krpano_var) {
        return (window.krpano = krpano_var.get("global"));
    };

    window.init = function () {
        window.onpopstate = function (event) {
            if (!event.state) {
                window.location.href = window.location.href;
                return;
            }

            windowPopState = true;
            if (event.state.pano) {
                loadPano(getPanoByName(event.state.pano));
            }
        };

        krpano.view.fov = 120;
        krpano.view.fovtype = "mfov";
        krpano.view.maxpixelzoom = 1.0;
        krpano.view.fovmax = 120;
        krpano.view.limitview = "auto";

        krpano.control.mouse = "follow";
        krpano.control.touch = "follow";
        krpano.logkey = false;

        krpano.cursors.standard = "grab";
        krpano.cursors.dragging = "grabbing";
        krpano.cursors.moving = "grabbing";

        setupGlobalEvents();

        // Loader
        addPlugin({
            name: "loader",
            keep: true,
            type: "container",
            bgcolor: 0xffcb35,
            bgalpha: 1.0,
            width: 0,
            height: 4,
            zorder: 999999,
        });

        // Gyroscope
        if (!krpano.device.desktop) {
            addPlugin({
                name: "gyro",
                keep: true,
                url: krpano.ext_base + "js/plugins/gyro2.js",
                enabled: "false",
            });
        }

        // // Older browser IE warning
        // if (krpano.device.ie) {
        //     addPlugin({
        //         name: 'ie-message',
        //         keep: true,
        //         type: 'text',
        //         width: '100%',
        //         align: 'top',
        //         css: 'color:white;text-align:center;font-size:20px',
        //         bgcolor: '#FF0000',
        //         height: Math.max(50, 500 / krpano.area.pixelwidth * 100),
        //         html: 'You\'re using an outdated browser. For the best experience visit outdatedbrowser.com and update to the latest one.',
        //         vcenter: true,
        //         zorder: 999999999999,
        //         onclick: "openurl(http://outdatedbrowser.com,_blank)",
        //         padding: 10
        //     });
        // }

        // Follow mouse event
        var followSpeed = 0.05;
        var followRange = 5;
        var followFactor = 1;
        var track_ry = 0;
        var track_rx = 0;
        var fmEvent = krpano.events.createItem("follow-mouse");
        fmEvent.keep = true;

        fmEvent.onviewchanged = function () {
            krpano.view.haschanged = true;
        };

        fmEvent.onviewchange = function () {
            if (
                krpano.mouse.x !== 0 &&
                krpano.mouse.y !== 0 &&
                krpano.disable_followmouse !== true
            ) {
                var zoomScale = Math.tan((krpano.view.vfov * 0.5 * Math.PI) / 180);
                zoomScale = 1 / zoomScale;
                zoomScale = Math.max(zoomScale, 1 / zoomScale);
                var new_ry =
                    (followFactor / zoomScale) *
                    followRange *
                    (krpano.mouse.x / krpano.area.pixelwidth - 0.5);
                var new_rx =
                    (followFactor / zoomScale) *
                    followRange *
                    (krpano.mouse.y / krpano.area.pixelheight - 0.5);
                track_ry = track_ry * (1 - followSpeed) + new_ry * followSpeed;
                track_rx = track_rx * (1 - followSpeed) + new_rx * followSpeed;
                krpano.view.ry = track_ry;
                krpano.view.rx = track_rx;
            }
        };

        fmEvent.onmousedown = function () {
            krpano.call("stopdelayedcall(followmouse_reenable);tween(followfactor,0.0,0.2);");
        };

        fmEvent.onmouseup = function () {
            krpano.call("delayedcall(followmouse_reenable, 1.0, tween(followfactor,1.0,3.0));");
        };

        loadAllPanos();
        initializeGUI();
    };

    window.setupGlobalEvents = function setupGlobalEvents() {
        // set up krpano events
        krpano.events.onresize = onResize;
        krpano.events.onxmlcomplete = onXMLComplete;
        krpano.events.onmousedown = onMouseDown;
    };

    window.loadAllPanos = function loadAllPanos() {
        allPanos = krpano.tour.pano.getArray().reduce(function (a, c) {
            return a.concat(c);
        }, []);
    };

    window.loadFirstPano = function loadFirstPano() {
        if (krpano.ext_path == "/") {
            if (krpano.tour.start === "empty") {
                krpano.call("loadxml(<krpano />)");
                loadGUI();
            } else {
                loadPano(getPanoByName(krpano.tour.start));
            }
        } else {
            var urlSegments = krpano.ext_path.split("/").filter(Boolean);
            if (urlSegments.length) {
                loadPano(getPanoByName(urlSegments[0]));
            }
        }
    };

    window.loadPano = function loadPano(pano) {
        unloadGUI(function () {
            krpano.call(
                "set(current_pano_name," +
                    pano.name +
                    ");loadpano(/xml/panos/" +
                    pano.name +
                    ".xml?h=" +
                    Math.round(Math.random() * 10000) +
                    ",null,,OPENBLEND(0.5, 0.0, 0.75, 0.05, easeinoutcubic),js(loadHotspots()));"
            );
            document.dispatchEvent(loadPanoEvent);
            // Send event to parent
            if (window.parent !== undefined && window.parent.length) {
                window.parent.postMessage(
                    {
                        pano: pano.name,
                    },
                    "*"
                );
            }
        });
    };

    window.loadHotspots = function loadHotspots() {
        if (!krpano.gui_js_loaded) {
            setTimeout(loadHotspots, 100);
            return;
        }

        if (!getCurrentPano() || !getCurrentPano().hotspot) {
            krpano.gui_loading = false;
            krpano.gui_loaded = true;
            return;
        }

        unloadHotspots(true);
        hotspots = [];

        loadHotspot(Array.from(getCurrentPano().hotspot.getArray()));
    };

    window.unloadHotspots = function unloadHotspots(force) {
        if (hotspots.length) {
            hotspots.forEach(function (hotspot) {
                if (force) {
                    krpano.removehotspot(hotspot.name);
                } else {
                    try {
                        hotspot.remove();
                    } catch (error) {
                        krpano.removehotspot(hotspot.name);
                    }
                }
            });
        }
    };

    window.loadHotspot = function loadHotspot(hotspotList) {
        var element = hotspotList.pop();
        if (!element) return;
        var name = element.name + "_" + Math.round(Math.random() * 10000);

        switch (element.type) {
            case "nav":
                var _element$zoom;
                hotspots.push(
                    addHotspot({
                        name: name,
                        url:
                            krpano.ext_base +
                            "dist/plugins/hotspot.min.js?h=" +
                            Math.round(Math.random() * 10000),
                        renderer: "css3d",
                        src: element,
                        zoom:
                            (_element$zoom = element.zoom) !== null && _element$zoom !== void 0
                                ? _element$zoom
                                : false,
                    })
                );
                break;

            default:
                break;
        }

        if (hotspotList.length) {
            setTimeout(function () {
                loadHotspot(hotspotList);
            }, 50);
        } else {
            krpano.gui_loading = false;
            krpano.gui_loaded = true;
        }
    };

    window.addHotspot = function addHotspot(c, t) {
        var h = krpano.addhotspot(c.name);
        for (var x in t) {
            h[x] = t[x];
        }
        for (var _x2 in c) {
            h[_x2] = c[_x2];
        }
        return h;
    };

    window.addPlugin = function (c, t) {
        var p = krpano.addplugin(c.name);
        for (var x in t) {
            p[x] = t[x];
        }
        for (var _x in c) {
            p[_x] = c[_x];
        }
        return p;
    };

    window.initializeGUI = function initializeGUI() {
        addPlugin({
            name: "gui",
            url: krpano.ext_base + "dist/plugins/gui.min.js?h=" + Math.round(Math.random() * 10000),
            keep: true,
            zorder: 10,
        });

        loadGUI();
    };

    window.loadGUI = function loadGUI() {
        if (krpano.gui_loaded) return;
        if (krpano.gui_loading) return;
        krpano.gui_loading = true;

        loadFirstPano();
    };

    window.unloadGUI = function unloadGUI(callback) {
        if (krpano.gui_loaded === false) return;

        unloadHotspots();
        krpano.gui_loaded = false;

        setTimeout(callback, 350);
    };

    window.updateURL = function updateURL(panoName) {
        if (allPanos.length === 1 || getCurrentPano() === undefined) return;

        var urlParams = "";
        var locationData = krpano.ext_base + getCurrentPano().name + urlParams;

        if (windowPopState) {
            windowPopState = false;
        } else {
            window.history.pushState(
                {
                    pano: getCurrentPano().name,
                },
                "",
                locationData
            );
        }
    };

    window.getPanoByName = function getPanoByName(name) {
        return allPanos.find(function (pano) {
            return pano.name.toLowerCase() === name.toLowerCase();
        });
    };

    window.getCurrentPano = function getCurrentPano() {
        return allPanos.find(function (element) {
            try {
                return (
                    (element === null || element === void 0
                        ? void 0
                        : element.name.toLowerCase()) === krpano.current_pano_name
                );
            } catch (err) {
                return null;
            }
        });
    };

    // Events
    window.onMouseDown = function onMouseDown() {};

    window.onResize = function onResize() {
        // krpano.is_mobile = krpano.area.pixelwidth < 1025; //
    };

    window.onXMLComplete = function onXMLComplete() {
        if (krpano.plugin.getItem("loader")) {
            krpano.plugin.getItem("loader").width = 0;
            krpano.plugin.getItem("loader").alpha = 1;
            var progressInterval = setInterval(function() {
                if (!krpano.plugin.getItem("loader")) return;

                if (krpano.progress.progress < 1) {
                    TweenLite.to(krpano.plugin.getItem("loader"), 0.1, {
                        width: krpano.area.pixelwidth * krpano.progress.progress,
                    });
                } else {
                    krpano.plugin.getItem("loader").width = 0;
                    TweenLite.to(krpano.plugin.getItem("loader"), 0.25, {
                        alpha: 0,
                        onComplete: loadGUI(),
                        delay: 0.5,
                    });
                    if( progressInterval ) {
                        clearInterval(progressInterval);
                    }
                }
            }, 100);
        }

        if (getCurrentPano() && getCurrentPano().type == "video") {
            // Disable user controls
            krpano.control.usercontrol = "off";

            // Load & initialize videoplayer
            panoVideoPlugin = krpano.addplugin("pano_video_player");
            panoVideoPlugin.url = krpano.ext_base + "js/plugins/videoplayer.js";
            panoVideoPlugin.loop = getCurrentPano().loop ?? true;
            panoVideoPlugin.panovideo = true;
            panoVideoPlugin.pausedonstart = getCurrentPano().paused ?? false;
            panoVideoPlugin.videourl = krpano.image.sphere.video_url;
            panoVideoPlugin.posterurl = krpano.image.sphere.video_url.replace(
                /webm|mp4|mov/g,
                "jpg"
            );
            panoVideoPlugin.first = krpano.user_interaction !== true;
            panoVideoPlugin.userinteractionworkarounds = true;

            // Videoplayer events
            panoVideoPlugin.onneeduserinteraction = function () {};

            panoVideoPlugin.onvideocomplete = function () {};

            panoVideoPlugin.onvideoplay = function () {
                // Re-enable user controls
                krpano.control.usercontrol = "all";
            };

            panoVideoPlugin.onvideopaused = function () {};

            panoVideoPlugin.onvideoready = function () {};
        }

        updateURL();
    };
}
